// eslint-disable-next-line import/prefer-default-export
export const routeOn = (push, on, definition, current) => {
  if (definition[on] && definition[on] !== current) {
    push(definition[on]);
  }
};
